import { LoginContext } from "./Context/LoginContext";
import {useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthMedic = () => {
    const NavigateAuth = useNavigate();
    const { validador } = useContext(LoginContext);
    const CheckAuth = () =>{
        if (validador === 2) {
        
        }

        else {
        NavigateAuth("/");
        }
    }
    useEffect(() => {
        CheckAuth();
      }, []);
};

export default AuthMedic;